export const MCP_INSTALL_COMMAND = 'npx @posthog/wizard mcp add'
